import Vue from 'vue';
import App from './App.vue';
import JsonCSV from 'vue-json-csv';
import BootstrapVue from "bootstrap-vue";
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// import '@aws-amplify/ui-vue';
// import Amplify from 'aws-amplify';
import { Amplify } from 'aws-amplify';
// Generated at build/serve time from src/config/<DBCSI_ENV>.json (scripts/gen-config.js)
import awsConfig from './aws-config';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

Amplify.configure({
  ...awsConfig.amplify,
  oauth: {
    domain: awsConfig.oauthDomain,
    scope: ['openid', 'email', 'profile'],
    // Redirects derive from the running origin so dev (localhost) and prod both work;
    // these must be listed as callback/logout URLs on the web app client (see override.ts).
    redirectSignIn: window.location.origin + '/',
    redirectSignOut: window.location.origin + '/',
    responseType: 'code',
  },
});

Vue.use(BootstrapVue);
Vue.component('downloadCsv', JsonCSV);

Vue.config.productionTip = false;

applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app');
